// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"Page_ErrorContainer__Pmbch","ErrorTitle":"Page_ErrorTitle__NoUo1","ErrorMessage":"Page_ErrorMessage__aKJYc"};